import { getCurrentCoreSubscription } from './user-subscription';
import moment from 'moment';

export const shouldShowReferAdviserPage = (userSubscription, teamShortNames) => {
  const currentCoreSubscription = getCurrentCoreSubscription(userSubscription);
  if (currentCoreSubscription) {
    const { startedAt } = currentCoreSubscription || {};

    if (startedAt) {
      const is3DaysAfterSubscriptionStart = moment(currentCoreSubscription.startedAt)
        .add(3, 'days')
        .isBefore(moment());

      if (
        teamShortNames &&
        (teamShortNames.includes('CBB') || teamShortNames.includes('CBBTrainer') || teamShortNames.includes('demo'))
      ) {
        return false;
      } else if (!is3DaysAfterSubscriptionStart) {
        return false;
      } else {
        return true;
      }
    }
  }

  return false;
};
